import {
  BRAND_TYPE_VALUES,
  CUSTOMER_TYPE_VALUES,
  PRODUCT_TYPE_VALUES,
} from './schema';

export interface Option<V extends string> {
  label: string;
  value: V;
}

export const CUSTOMER_TYPES: Option<CUSTOMER_TYPE_VALUES>[] = [
  {
    label: "I'm on an O2 Pay Monthly tariff",
    value: CUSTOMER_TYPE_VALUES.PAY_MONTHLY,
  },
  {
    label: "I'm on an O2 Pay As You Go tariff",
    value: CUSTOMER_TYPE_VALUES.PAY_AS_GO,
  },
  {
    label: "I'm on an O2 Business tariff",
    value: CUSTOMER_TYPE_VALUES.BUSINESS,
  },
  {
    label: "I'm not currently on O2",
    value: CUSTOMER_TYPE_VALUES.NOT_CUSTOMER,
  },
];

export const BRANDS: Option<BRAND_TYPE_VALUES>[] = [
  { label: 'Apple', value: BRAND_TYPE_VALUES.APPLE_BRAND },
  { label: 'Samsung', value: BRAND_TYPE_VALUES.SAMSUNG_BRAND },
  { label: 'Google', value: BRAND_TYPE_VALUES.GOOGLE_BRAND },
  { label: 'Sony', value: BRAND_TYPE_VALUES.SONY_BRAND },
  { label: 'Other Brands', value: BRAND_TYPE_VALUES.OTHER_BRAND },
];

export const PRODUCTS_SERVICES: Option<PRODUCT_TYPE_VALUES>[] = [
  { label: 'Phones', value: PRODUCT_TYPE_VALUES.PHONE_PRODUCTS },
  {
    label: 'Tablets and Connected Laptops',
    value: PRODUCT_TYPE_VALUES.TABLET_PRODUCTS,
  },
  {
    label: 'O2 Satellite',
    value: PRODUCT_TYPE_VALUES.SAT_PRODUCTS,
  },
  { label: 'Accessories', value: PRODUCT_TYPE_VALUES.ACCESSORY_PRODUCTS },
  { label: '5G', value: PRODUCT_TYPE_VALUES.FIVEG_PRODUCTS },
  {
    label: 'Perks, extras and promotions',
    value: PRODUCT_TYPE_VALUES.PERK_PRODUCTS,
  },
  {
    label: 'New products and service launches',
    value: PRODUCT_TYPE_VALUES.NEW_PRODUCTS,
  },
];
